import React from "react"
import { Link } from "react-router-dom"
import Navigation from "./Header/Navigation"

export default function Header(props) {

  return (
    <div className="header">
      <Link to="/" className="header__text">
        <h1 className="header__title">RailAdmin</h1>
        <p className="header__sub-title">Hubba lubba dub dub</p>
      </Link>
      <Navigation showModal={props.showModal} setShowModal={props.setShowModal} />
    </div>
  )
}